import { render } from "./PageTransitionsNr2.vue?vue&type=template&id=08786246&scoped=true"
import script from "./PageTransitionsNr2.vue?vue&type=script&lang=js"
export * from "./PageTransitionsNr2.vue?vue&type=script&lang=js"

import "./PageTransitionsNr2.vue?vue&type=style&index=0&id=08786246&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08786246"]])

export default __exports__